import React, { useState } from "react";

function FacebookIcon({ width = 24, height = 24 }) {
  const [size] = useState({
    width,
    height,
  });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size.width}
      height={size.height}
      viewBox="0 0 24 24"
    >
      <g id="facebook" transform="translate(0 -0.253)">
        <circle
          id="Ellipse_105"
          data-name="Ellipse 105"
          cx="12"
          cy="12"
          r="12"
          transform="translate(0 0.253)"
          fill="#3b5998"
        />
        <path
          id="Path_2187"
          data-name="Path 2187"
          d="M44.8,29.65H42.644v7.918H39.369V29.65H37.812V26.868h1.557v-1.8a3.07,3.07,0,0,1,3.3-3.3l2.425.01v2.7h-1.76a.667.667,0,0,0-.695.758V26.87h2.447Z"
          transform="translate(-29.648 -17.036)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default FacebookIcon;
